// ----------------------------------------------------------------------------
// Section: Product Slider
// ----------------------------------------------------------------------------
//
// This is a section that displays product slider items and optional button
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { Navigation, Scrollbar, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_stores-carousel.scss';



const initStoresCarousel = (storeCarousel) => {
    const carousel   = storeCarousel.querySelector('.carousel--stores-carousel')
    const prevButton = storeCarousel.querySelector('.stores-button-prev');
    const nextButton = storeCarousel.querySelector('.stores-button-next');
    const scrollbar  = storeCarousel.querySelector('.swiper-scrollbar');

    const swiper = new Swiper(carousel, {
        modules: [Navigation, Scrollbar, A11y, Keyboard],
        slidesPerView: 1.1,
        spaceBetween: 10,
        centerInsufficientSlides: true,
        observer: true,
        observeParents: true,
        a11y: false,
        watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
        grabCursor: true,

        breakpoints: {
            0: {
                slidesPerView: 1.2264,
                spaceBetween: 13.66,
            },
            681: {
                slidesPerView: 3,
                spaceBetween: 20,
            }
        },
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        },
        scrollbar: {
            el: scrollbar,
            draggable: true,
        }
    });

    swiper.slides.forEach(function(slide, index) {
        const slideLink = slide.querySelector('a');

        slideLink?.addEventListener('focus', function(e) {
            swiper.slideTo(index);
        })
    });
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    const storeCarousels = document.querySelectorAll('.carousel--stores-carousel-container');

    storeCarousels.forEach((storeCarousel) => {
        initStoresCarousel(storeCarousel);
    });
});
